<template>
  <div class="wrapper col-md-6">
    <div class="panel panel-default">
      <div class="panel-title">
        <h3>Nouveaux clients</h3>

        <router-link :to="{ name: 'customers' }">
          <span class="btn btn-sm btn-primary top-right m-b-15">
            Voir tout
          </span>
        </router-link>

      </div>
      <div class="panel-body"
           v-if="customers">
        <new-customers-item v-for="(everyone, idx) in customers"
                            :key="'dashboard-new-customers-'+idx"
                            :customer="everyone"
                            v-if="idx < 3">
        </new-customers-item>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .wrapper {
    padding-left: 10px;
    padding-right: 10px;
    width: calc(50% - 10px);
    @media all and (max-width: 1199px) {
      padding: 0;
      width: 100%;
    }
  }

  .panel {
    padding: 0;
    background: transparent;
    border: none;
    @media all and (max-width: 767px) {
      padding: 0 20px;
    }
    .panel-title {
      position: relative;
      h3 {
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
      }
      button {
        position: absolute;
        right: 5px;
      }
    }
    .panel-body {
      padding: 0;
    }
  }
</style>

<script type="text/babel">
  import { mapGetters, mapActions, mapState } from 'vuex'
  import NewCustomersItem from 'components/Dashboard/NewCustomers/NewCustomersItem'

  export default {
    name: "NewCustomers",

    props: ["customers"],

    components: {
      NewCustomersItem
    },

    data () {
      return {
      }
    },

  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/NewCustomers/NewCustomers.vue